import { render, staticRenderFns } from "./Loyalty.vue?vue&type=template&id=4395d20e&scoped=true"
import script from "./Loyalty.vue?vue&type=script&lang=ts"
export * from "./Loyalty.vue?vue&type=script&lang=ts"
import style0 from "./Loyalty.vue?vue&type=style&index=0&id=4395d20e&prod&scoped=true&lang=css"
import style1 from "./Loyalty.vue?vue&type=style&index=1&id=4395d20e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4395d20e",
  null
  
)

export default component.exports